import ko from 'knockout';

export default class AfasHrVarModel {
    enabled: KnockoutObservable<boolean>;
    description: KnockoutObservable<string>;
    value: KnockoutObservable<string>;
    number: KnockoutObservable<string>;

    constructor(enabled: boolean, description: string, value: string, parameter: string) {
        this.enabled = ko.observable<boolean>(enabled);
        this.description = ko.observable<string>(description);
        this.value = ko.observable<string>(value);
        this.number = ko.observable<string>(parameter);
    }
}
